<template>
  <div class="club-page">
    <div class="top-banner">
      <img src="@/assets/img/club/family/dragons_family.png" alt="dragons_family">
    </div>

    <div class="btn-div">
      <a href="https://naver.me/Ge7N510u" target="_blank" class="btn-map">
        드래곤즈 패밀리 지도 <img src="@/assets/img/icon/icon_arrow.svg" alt="icon_arrow">
      </a>
      <a href="https://naver.me/5FDtrNRF" target="_blank" class="btn-map">
        드래곤즈 패밀리 신청하기 <img src="@/assets/img/icon/icon_arrow.svg" alt="icon_arrow">
      </a>
    </div>

    <div class="line"></div>

    <div>
      <div v-if="familyList.length" class="grid-list">
        <div
          v-for="(item, index) in familyList"
          :key="index" class="item">
          <!--
          <router-link :to="{ name: 'clubDetail', params: { id: item.seq } }" >
          </router-link>
           -->
          <img
            :src="imageSrc(item.seq)"
            class="club-img"
            alt="dragons-family"
            @error="handleImgError"
          >

          <div class="club-info">
            <p class="family" v-html="item.title"></p>
            <p class="address">
              <img src="@/assets/img/icon/icon_map.svg" alt="icon_map">
              <span v-html="item.address"></span>
            </p>
            <p class="address map"><img src="@/assets/img/icon/icon_phone.svg" alt="icon_phone"> {{ item.phone }}</p>
            <p class="ceo">대표. {{ item.ceo }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isEmpty } from '@/lib';
import defaultImg from '@/assets/img/feed_default.png';

export default {
  name: 'DragonsFamily',

  data() {
    return {
      defaultImg,
      familyList: []
    };
  },

  mounted() {
    this.getList();
  },

  methods: {
    isEmpty,
    handleImgError(e) {
      e.target.src = this.defaultImg;
    },
    imageSrc(imgSrc) {
      return require('@/assets/img/club/family/'+imgSrc+'.png');
    },
    getList() {
      this.familyList = [
        {
          img: '',
          seq: '1',
          title: '모리',
          address: '전남광주 광양시 길호5길2 1층',
          phone: '061-792-8009',
          ceo: '김정민'
        },
        {
          img: '',
          seq: '2',
          title: '현대데코빌',
          address: '전남광주 광양시 사동로 238',
          phone: '061-791-4594',
          ceo: '박문옥'
        },
        {
          img: '',
          seq: '3',
          title: '더큰장어',
          address: '전남광주 광양시 항만9로 101',
          phone: '061-794-1333',
          ceo: '강여용'
        },
        {
          img: '',
          seq: '4',
          title: '우정',
          address: '전남광주 광양시 항만9로 109 2층',
          phone: '061-817-0403',
          ceo: '김영대'
        },
        {
          img: '',
          seq: '5',
          title: '대복삼계탕',
          address: '전남광주 광양시 항만9로 109 2층',
          phone: '061-793-9999',
          ceo: '허숙희'
        },
        {
          img: '',
          seq: '6',
          title: '그러소',
          address: '전남광주 광양시 광양읍 매천로 714',
          phone: '061-762-9291',
          ceo: '박정남'
        },
        {
          img: '',
          seq: '7',
          title: '타이어모어 광양점/<br>티스테이션 포스코점',
          address: '전남광주 광양시 중마로 154/<br>&nbsp;&nbsp;&nbsp;&nbsp;전남광주 광양시 백운1로 3',
          phone: '-',
          ceo: '허현'
        }
      ];
    }
  }
};
</script>

<style scoped>
.club-page {
  padding-bottom: 80px;
}

.top-banner {
  /*width: 100%;
  height: 200px;
  border-radius: 12px;
  background: #f5f5f5;

  display: flex;
  align-items: center;
  justify-content: center;

  color: #666;
  font-size: 16px;*/
}

.line {
  width: 100%;
  height: 1px;
  background: #E3E3E3;
  margin: 64px 0;
}

.grid-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  row-gap: 48px;
  column-gap: 16px;
}

.item {
  overflow: hidden;
  background: #fff;
  transition: 0.2s ease;
}

.item:hover {
  transform: translateY(-2px);
}

.item a {
  display: block;
  text-decoration: none;
  color: inherit;
}

.club-img {
  width: 100%;
  object-fit: cover;
  display: block;
  height: 156.375px;
  align-self: stretch;
  aspect-ratio: 16/9;
}

.club-info {
  display: flex;
  flex-direction: column;
  padding-top: 12px;
}

.family {
  color: #020514;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  padding-bottom: 8px;
}

.address {
  color: #363739;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.map {
  margin-top: 4px;
}

.ceo {
  display: flex;
  padding: 5px 8px;
  align-items: center;
  gap: 4px;
  border-radius: 99px;
  color: #020514;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  width: max-content;
  margin-top: 24px;
  border: 1px solid #3A3B3D;
}

.btn-map {
  background: #000;
  display: flex;
  width: 200px;
  height: 48px;
  padding: 12px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  color: #FFF;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 100%; /* 14px */
}

.btn-div {
  margin-top: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
}

/* 모바일 */
@media (max-width: 768px) {
  .grid-list {
    grid-template-columns: 1fr;
  }

  .club-img {
    height: auto;
  }

  .btn-div {
    display: grid;
  }
}
</style>
